export default "/images/vendor/flag-icon-css/flags/4x3/rw.svg?26854553b660fa5e4982e8253545fa3c";